/*
 * @Description: 管理员账号管理 接口
 * @Autor: lwq
 * @Date: 2020-07-17 10:40:33
 * @LastEditors: lwq
 * @LastEditTime: 2020-07-17 18:16:41
 * @FilePath: \mrc-base-server-view\src\service\api\admin_account_manage.js
 */

import http from '../httpConfig'

const table = 'mrbase_sys_users'

/**
 * @description: 列表
 * @param {type} 
 * @return: 
 * @author: lwq
 */
export const admin_account_list = (params = {}) => {
        params['~table~'] = table
        return new Promise((resolve, reject) => {
            http.post('/api/management/list-user/v1', params)
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                })
        })
    }
    /**
     * @description: 新增
     * @param {type} 
     * @return: 
     * @author: lwq
     */
export const admin_account_add = (params = {}) => {
        params['~table~'] = table
        return new Promise((resolve, reject) => {
            http.post('/api/management/add-user/v1', params)
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                })
        })
    }
    /**
     * @description: 修改
     * @param {type} 
     * @return: 
     * @author: lwq
     */
export const admin_account_update = (params = {}) => {
        params['~table~'] = table
        return new Promise((resolve, reject) => {
            http.post('/api/management/update-user/v1', params)
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                })
        })
    }
    /**
     * @description: 重置
     * @param {type} 
     * @return: 
     * @author: lwq
     */
export const admin_account_reset = (params = {}) => {
        params['~table~'] = table
        return new Promise((resolve, reject) => {
            http.post('/api/management/update-reset-password/v1', params)
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                })
        })
    }
    /**
     * @description: 禁用
     * @param {type} 
     * @return: 
     * @author: lwq
     */
export const admin_account_disable = (params = {}) => {
        params['~table~'] = table
        return new Promise((resolve, reject) => {
            http.post('/api/management/update-disable-account/v1', params)
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                })
        })
    }
    /**
     * @description: 详情
     * @param {type} 
     * @return: 
     * @author: lwq
     */
export const admin_account_info = (params = {}) => {
        params['~table~'] = table
        return new Promise((resolve, reject) => {
            http.post('/api/management/find-user/v1', params)
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                })
        })
    }
    /**
     * @description: 删除
     * @param {type} 
     * @return: 
     * @author: lwq
     */
export const admin_account_del = (params = {}) => {
    params['~table~'] = table
    return new Promise((resolve, reject) => {
        http.post('/api/management/delete-user/v1', params)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

/**
 * @description: 功能权限列表
 * @param {interface} /api/role/list-function_role-clients/v1
 * @return: 
 * @author: lwq
 */

export const func_list = (params = {}) => {
        params['~table~'] = 'mrbase_sys_role'
        return new Promise((resolve, reject) => {
            http.post('/api/role/list-function_role-clients/v1', params)
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                })
        })
    }
    /**
     * @description: 根据人员带出客户
     * @param {interface} /api/management/find-staff-user/v1
     * @return: 
     * @author: lwq
     */

export const takeout_customer = (params = {}) => {
    params['~table~'] = 'mrbase_sys_staffs'
    return new Promise((resolve, reject) => {
        http.post('/api/management/find-staff-user/v1', params)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}